export default __webpack_public_path__ + "static/media/1138.c93ea273.png";